<template>
  <div class="w-100 h-100" style="overflow: hidden;">
    <canvas id="myCanvas" class="" ref="canvasRef" :style="getCanvasSize"></canvas>
  </div>
</template>

<script>
import * as THREE from "@/js/three/three.js";
import { OffScreen } from "@/js/OffScreen.js";
import { CreateImageElement } from "@/js/CommonFunc.js";
import { PreviewColorList, GetCanvasSize } from "@/js/Const.js";

import { ColladaLoader } from "@/js/three/ColladaLoader.js";// eslint-disable-line
import { OrbitControls } from "@/js/three/OrbitControls.js";// eslint-disable-line

export default {
  name: "CenterViewPreview3dPlate_Ap",
  props: {},
  data: function () {
    this.scene = null
    this.camera = null
    this.renderer = null
    this.cube = null
    this.controls = null
    this.model = null

    return {
      offScreen:null,
      canvasTexture:null,
      updateTimer:null,
    };
  },
  computed: {
    getCanvasSize(){
      let canvasSize = GetCanvasSize(this.$store.state.commonPreviewData.selectProductId);
      return {
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
  },
  watch:{
    "$store.state.commonPreviewData.selectBackgroundColor":function(){
      let color = PreviewColorList[this.$store.state.commonPreviewData.selectBackgroundColor];
      this.scene.background = new THREE.Color( color );
    },
    "$store.state.commonPreviewData.designImageURL":async function(){
      await this.resetImage();
    },
    "$store.state.commonPreviewData.frameCutlineImageURL":async function(){
      await this.resetImage();
    },
  },
  created:function(){
    this.offScreen = new OffScreen(1400, 2240);
    this.updateTimer = setInterval( function(){
      this.tick();
    }.bind(this), 10 );
  },
  destroyed(){
    console.log("destroyed");
    clearInterval(this.updateTimer);
    this.$store.commit("setResetCameraFunc", null);
  },
  async mounted() {
    console.log("mounted");
    this.init()
    await this.addModel()
    //this.addBox()
    this.animate()
    this.$store.commit("setResetCameraFunc", this.resetCamera);
  },
  components: {},
  methods: {

    async resetImage(){
      this.offScreen.clear();

      if( this.$store.state.commonPreviewData.designImageURL ){
        let image = await CreateImageElement(this.$store.state.commonPreviewData.designImageURL);
        this.offScreen.drawImage(image, 0, 0, 1400, 2240);
      }

      if( this.$store.state.commonPreviewData.frameCutlineImageURL ){
        let image = await CreateImageElement(this.$store.state.commonPreviewData.frameCutlineImageURL);
        this.offScreen.drawImage(image, 0, 0, 1400, 2240);
      }

      // if( this.$store.state.cutlineImageURL ){
      //   let image = await CreateImageElement(this.$store.state.cutlineImageURL);
      //   this.offScreen.drawImage(image, 0, 0, 1400, 2240);
      // }

      // var canvasTexture = new THREE.CanvasTexture(this.offScreen.canvas);
      if( this.canvasTexture != null ){
        this.canvasTexture.needsUpdate = true;
      }
      // model.children[1].material.map = canvasTexture;
      // model.children[2].material.map = canvasTexture;

      //offCanvas.downloadImage();
      // return offCanvas.canvasImage();
      // return offCanvas.canvas;
    },

    // loadImage(url){
    //   return new Promise((resolve) => {
    //     var backimg = new Image();
    //     backimg.crossOrigin = 'Anonymous'
    //     backimg.onload = () => {
    //       resolve(backimg);
    //     };
    //     backimg.src = url;
    //   });
    // },

    resetCamera(){
      this.controls.reset();
      // this.controls = new THREE.OrbitControls(this.camera, this.$refs.canvasRef);
    },

    init() {

      // const CanvasWidth = this.$refs.canvasRef.width;
      // const CanvasHeight = this.$refs.canvasRef.height;
      const CanvasWidth = 1400
      const CanvasHeight = 2240

      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color( PreviewColorList[this.$store.state.commonPreviewData.selectBackgroundColor] );
      this.camera = new THREE.PerspectiveCamera(
        45, // FOV
        CanvasWidth/CanvasHeight, // aspect ratio
        0.01, // near
        1000 // far
      )
      this.renderer = new THREE.WebGLRenderer({ 
        canvas: this.$refs.canvasRef,
        antialias: true,
        alpha: true,
        preserveDrawingBuffer: true,
      })
      this.renderer.shadowMap.enabled = true;

      // レンダリング解像度
      this.renderer.setSize(
        CanvasWidth,
        CanvasHeight,
        false
      )

      // カメラの初期位置を設定
      this.camera.position.y = 0.0;
      this.camera.position.z = 0.19;
      this.camera.rotation.x = 0.0;
      this.camera.rotation.y = 0.0;
      this.camera.rotation.z = 0.0;
      this.controls = new THREE.OrbitControls(this.camera, this.$refs.canvasRef);
    },

    addBox() {
      const geometry = new THREE.BoxGeometry()
      const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 })
      this.cube = new THREE.Mesh(geometry, material)
    },

    async addModel(){
      // Collada形式のモデルデータを読み込む
      const loader = new THREE.ColladaLoader();

      // Colladaファイルのパスを指定
      loader.load("/model/acryl_3DPreview_3pori.dae", (collada) => {
        // 読み込み後に3D空間に追加
        const model = collada.scene;
        model.scale.x = 1
        model.scale.y = 1
        model.scale.z = 1
        model.position.y = -0.071

        var textureLoader = new THREE.TextureLoader();
        var texture = textureLoader.load("/model/body_tex_02.png");
        console.log(texture);

        // 0 body
        // 1 back
        // 2 front

        // model.children[0].material[0].wireframe = true;
        // model.children[0].material[1].wireframe = true;
        // model.children[1].material[0].wireframe = true;
        // model.children[2].material[0].wireframe = true;
        model.children[0].castShadow = true;


        // model.children[0].material[0].opacity = 0.1;
        // model.children[0].material[0].side = THREE.DoubleSide;
        model.children[0].material[1].opacity = 1.0;
        model.children[0].material[1].side = THREE.DoubleSide;

        model.children[0].material[0].alphaToCoverage = true;
        model.children[0].material[1].alphaToCoverage = true;
        model.children[1].material.alphaToCoverage = true;
        model.children[2].material.alphaToCoverage = true;

        model.children[1].material.transparent = true;
        model.children[2].material.transparent = true;

        // model.children[1].material.emissive.r = 0;
        // model.children[1].material.emissive.g = 0;
        // model.children[1].material.emissive.b = 0;
        // model.children[2].material.emissive.r = 0;
        // model.children[2].material.emissive.g = 0;
        // model.children[2].material.emissive.b = 0;

        // model.children[1].material = new THREE.MeshBasicMaterial()
        // model.children[2].material = new THREE.MeshBasicMaterial()

        this.canvasTexture = new THREE.CanvasTexture(this.offScreen.canvas);
        this.canvasTexture.needsUpdate = true;
        model.children[1].material.map = this.canvasTexture;
        model.children[2].material.map = this.canvasTexture;

        // model.children[1].material.transparent = true;
        // model.children[2].material.transparent = true;
        // model.children[1].material.alphaToCoverage = true;
        // model.children[2].material.alphaToCoverage = true;


        // 画像設定前は非表示
        // model.children[1].visible = false;
        // model.children[2].visible = false;

        // model.children.splice(1,2);
        // model.children[0].material.splice(0,1);



        this.model = model
        this.scene.add(model);
        console.log(model)
        // console.log(model.children[0].material[0])
        // console.log(model.children[0].material[1])
        // console.log(model.children[1].material)
        // console.log(model.children[2].material)

        this.scene.add(new THREE.AmbientLight(0xFFFFFF, 1.0));
        this.scene.add(new THREE.DirectionalLight(0xFFFFFF, 1));
      });

      // すでにテクスチャがアップロードされている可能性があるので更新
      await this.resetImage();

    },

    animate() {
      // this.renderer.render(this.scene, this.camera)
    },
    tick(){
      if( this.controls ){
        this.controls.update();
        this.renderer.render(this.scene, this.camera)
      }
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modelview {
  height: 100%;
  width: 100%;
}
</style>
